import { json, type MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { ArticleCard } from "~/components/article-card";
import { Layout } from "~/components/layout";
import { SearchInput } from "~/components/search-input";
import { getArticlesByType, type ArticleMeta } from "~/.server/content.server";

export const meta: MetaFunction = () => {
  return [
    { title: "Knowledge Base - Weather Route Support" },
    { name: "description", content: "Browse all knowledge base articles and guides for Weather Route." },
    { property: "og:title", content: "Knowledge Base - Weather Route Support" },
    { property: "og:description", content: "Browse all knowledge base articles and guides for Weather Route." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
    { name: "twitter:title", content: "Knowledge Base - Weather Route Support" },
    { name: "twitter:description", content: "Browse all knowledge base articles and guides for Weather Route." },
  ];
};

export async function loader() {
  const articles = await getArticlesByType('article');
  
  return json({
    articles,
  });
}

export default function KnowledgeBase() {
  const { articles } = useLoaderData<typeof loader>();
  
  return (
    <Layout>
      <div className="py-12 bg-gradient-to-b from-blue-50 to-white dark:from-slate-900 dark:to-slate-950">
        <div className="container px-4 mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-8">
            <h1 className="text-3xl font-bold mb-4">Knowledge Base</h1>
            <p className="text-slate-600 dark:text-slate-300 mb-6">
              Browse our comprehensive collection of articles and guides to help you get the most out of Weather Route.
            </p>
            
            <div className="max-w-xl mx-auto">
              <SearchInput expanded={true} placeholder="Search articles..." focusOnLoad={false} />
            </div>
          </div>
        </div>
      </div>
      
      <section className="py-12">
        <div className="container px-4 mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((article: ArticleMeta) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
          
          {articles.length === 0 && (
            <div className="text-center py-12">
              <p className="text-slate-500 dark:text-slate-400">No articles found.</p>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
} 